export const specialMenu = {
    crypto: 'Digital Currency',
    virtualCard: 'Virtual Card',
}
export const homeOneModule = {
    title: 'Secure Business Services',
    subTitle: 'Trusted Quality Service',
    descList: [
        {
            content: '10 Years of Experience'
        },
        {
            content: '9 Security Layers'
        },
        {
            content: '8 Service Scenarios'
        },
    ]
}
export const homeTwoModule = {
    title: 'One-stop Global Asset Management',
    subTitle: 'With UBPay, you can manage both stablecoins and fiat currencies on a single platform'
}
export const homeThreeModule = {
    title: 'UBPay: Your Best Global Business Partner',
    subTitle: 'We support instant stablecoin conversions at millisecond-level speed, eliminating the need to switch systems and minimizing market risks'
}
export const homeFourModule = {
    title: 'Fast, Secure, and Efficient Global Virtual Card Services',
    subTitleList: [
        {
            title: 'Fast Card Issuance, Instant Activation',
            subTitle: 'Instantly issue and use cards, saving time and effort',
            img: require('@/assets/imgs/home/gaoxiao.png')
        },
        {
            title: 'Advanced Technology, Strong Security',
            subTitle: 'A reliable technical infrastructure ensures smooth card and transaction processes',
            img: require('@/assets/imgs/home/jishu.png')
        },
        {
            title: 'Multiple Currencies, Convenient Transactions',
            subTitle: 'Offers cards in USD, EUR, GBP, and more to meet various payment needs and reduce currency exchange losses',
            img: require('@/assets/imgs/home/bizhong.png')
        },
    ]
}
export const appDownload = {
    title: 'Download APP',
    desc: 'UBPay is available as a mobile app on iOS and Android',
}
export const footerUbpayDesc = {
    content: 'Pacific and EAST Bank jointly established EAST Card Company with global HQ in New York and Hong Kong. They launched UB Card and UB Pay, ' +
        'set up a branch in Singapore, partnered with top banks, and hold Mastercard (HK) and Discover® Global Network (APAC) card licenses'
}
export const footerMenu = [
    {
        name: "Products & Services",
        router: "ps",
        childList: [
            // {
            //     name: "Multi-currency Wallet",
            //     url: "multiWalletAndCcy",
            // },
            // {
            //     name: "Stablecoin Conversion",
            //     url: "transformCcy",
            // },
            {
                name: "Virtual Bank Card",
                url: "footerVirtualCard",
            },
            {
                name: "Payment & Withdrawal",
                url: "payment",
            },
            {
                name: "Security",
                url: "security",
            },
        ]
    },
    {
        name: "About Us",
        router: "au",
        childList: [
            {
                name: "About UBPay",
                url: "aboutUbpay",
            },
            {
                name: "Contact Us",
                url: "contactUs",
            }
        ]
    },
    {
        name: "Policies & Regulations",
        router: "pr",
        childList: [
            // {
            //     name: "Terms of Use",
            //     url: "termsOfUse",
            // },
            {
                name: "Privacy Policy",
                url: "privacyPolicy",
            },
            {
                name: "Help Center",
                url: "helpCenter",
            }
        ]
    },
    {
        name: "APP",
        router: "app",
        childList: [
            {
                name: "App Download",
                url: "appDownload",
            }
        ]
    }
]
export const cryptoOneModule = {
    title: 'Supports Multiple Currencies and Chains',
    subTitle: 'We support multiple tokens and chains, allowing you to freely manage digital assets on one platform. Whether Ethereum or TRON, you can switch easily and trade instantly.'
}
export const cryptoTwoModule = {
    title: 'Stablecoin to fiat',
    subTitle: 'UBPay enables instant stablecoin conversion at millisecond speed. No need to switch systems, reducing market volatility risk and protecting asset value.'
}
export const cryptoThreeModule = {
    title: 'A professional team ensures the security of your crypto transactions',
    threeList: [
        {
            content: 'Low fees'
        },
        {
            content: 'Decentralized'
        },
        {
            content: '支持多条公链'
        },
        {
            content: 'Instant settlement'
        },
        {
            content: '稳定币兑换'
        },
        {
            content: '降低欺诈风险'
        },
        {
            content: '全球充提币'
        },
        {
            content: '24/7 customer support'
        },
    ]
}
export const virtualCardOneModule = {
    label: 'Dual network support: Discover & Mastercard',
    title: 'Full coverage of global online spending scenarios, meeting your diverse payment needs',
    subTitleList: [
        {
            img: require('@/assets/imgs/home/gaoxiao2.png'),
            title: "Instant card issuance, real-time arrival",
            content: "No waiting — apply online for a Discover/Mastercard virtual card and start global payments instantly"
        },
        {
            img: require('@/assets/imgs/home/jishu2.png'),
            title: "Advanced Technology, Strong Security",
            content: "A reliable technical infrastructure ensures smooth card and transaction processes"
        },
        {
            img: require('@/assets/imgs/home/bizhong2.png'),
            title: "Multiple Currencies, Convenient Transactions",
            content: "Offers cards in USD, EUR, GBP, and more to meet various payment needs and reduce currency exchange losses"
        },
        {
            img: require('@/assets/imgs/home/baozhang.png'),
            title: "Enjoy full anonymity with top-level privacy",
            content: "Virtual cards offer high anonymity—no real-name ID required, making it easy to issue while protecting your personal privacy."
        }
    ]
}
export const virtualCardTwoModule = {
    title: 'Discover and Mastercard card groups',
    cardGroup: [
        {
            name: 'Discover',
            descList: [
                {
                    content: 'Competitive pricing and smooth experience'
                },
                {
                    content: 'Multi-scenario supported, reusable anytime'
                },
                {
                    content: 'Shared limits for centralized enterprise card control'
                }
            ]
        },
        {
            name: 'Mastercard',
            descList: [
                {
                    content: '多场景支持，广泛的商户接受度'
                },
                {
                    content: '安全性和欺诈保护'
                },
                {
                    content: '良好的客户服务'
                }
            ]
        }
    ]
}
export const virtualCardThreeModule = {
    title: 'Instant issuance, easy management',
    openMgtList: [
        {
            title: 'Instant issuance',
            content: '无需等待，支持秒速开通Mastercard&DisCover虚拟卡，即开即用，开启全球之旅'
        },
        {
            title: 'Multiple currencies supported',
            content: '提供USD、EUR、GBP等多种卡片，满足特定币种支付需求，有效降低汇损'
        },
        {
            title: 'Advanced and stable tech',
            content: '稳定可靠的技术架构，卡片管理和支付流程保驾护航'
        },
        {
            title: '管理方便',
            content: '配套APP线上多卡统一管理，方便您随时查看和管理卡片信息'
        },
        {
            title: '全球支付',
            content: '支持主流支付平台线上支付，包括支付宝、微信支付、轻松应对跨境电商、海淘购物，线下支付贴心服务'
        },
        {
            title: 'Dedicated support, full coverage',
            content: 'Weekday live support for card issues'
        }
    ]
}
export const virtualCardFourModule = {
    title: 'Comprehensive privacy protection',
    privacyAndSecurityList: [
        {
            img: require('@/assets/imgs/home/rq.png'),
            title: "Enjoy full anonymity with top-level privacy",
            content: "Virtual cards offer high anonymity—no real-name ID required, making it easy to issue while protecting your personal privacy."
        },
        {
            img: require("@/assets/imgs/home/aq.png"),
            title: "Secure and reliable, with controllable risk.",
            content: "Each card is issued with a unique number to prevent information leakage. Virtual cards are isolated from your real account, helping protect against fraud during online purchases."
        },
        {
            img: require("@/assets/imgs/home/ed.png"),
            title: "Flexible spending control for smarter usage.",
            content: "Customize top-ups and set spending limits to avoid overspending and reduce risk. No credit check required, making flexible card access available to more users—breaking traditional financial barriers."
        },
    ]
}
export const popup = {
    productAndService: [
        {
            title: "收单",
            description: "支持快速接入，提供安全、高效的收款解决方案，兼容多种币种",
        },
        {
            title: "支付",
            description: "支持主流支付平台线上支付，包括支付宝、微信支付、轻松应对跨境电商、海淘购物，线下支付贴心服务",
        },
        {
            title: "多币种",
            description: "管理多种数字货币与法币，实现资金自由兑换与流转，覆盖主流币种",
        },
        {
            title: "稳定币转换",
            description: "币种实时、秒级转换，快速应对不稳定的市场",
        },
        {
            title: "安全",
            description: "银行级别风控，确保用户资金和账户安全",
        },
        {
            title: "费用",
            description: "透明低费率结构，无隐藏成本",
        }
    ],
    aboutUs: [
        {
            title: "关于ubpay",
            description: "在传统金融与区块链生态之间驾起合规、高速、安全的桥梁，让全球支付更加去中心化、数字化与智能化。",
        },
        {
            title: "联系我们",
            description: "专属客服与技术支持团队，7×24小时响应，助您高效解决业务问题。",
        },
    ],
    prContent: {
        regulationsOne: {
            subTitle: '1，简介',
            content: '本平台重视您的隐私，并致力于保护您的个人信息安全。本文《隐私条款》将说明我们在您访问我们的网站、使用我们的服务或与我们互动时，如何收集、使用、披露和保护您的信息。'
        },
        regulationsTwo: {
            subTitle: '2，我们收集的信息',
            content: '我们可能收集以下类型的信息：',
            list: [
                {
                    content: '个人身份信息（如姓名、身份证号、地址、电话号码、电子邮件）'
                },
                {
                    content: '财务信息（如银行账户、钱包地址、交易记录）'
                },
                {
                    content: '技术数据（如IP地址、浏览器类型、操作系统）'
                },
                {
                    content: '使用数据（如登录记录、点击行为、偏好设置）'
                },
                {
                    content: 'KYC信息（了解您的客户相关文件）'
                }
            ]
        },
        regulationsThree: {
            subTitle: '3，我们如何使用您的信息',
            content: '我们使用您的信息以：',
            list: [
                {
                    content: '提供、维护和改进我们的服务'
                },
                {
                    content: '验证您的身份并履行法律义务'
                },
                {
                    content: '处理交易和管理账户'
                },
                {
                    content: '防止欺诈、洗钱和非法活动'
                },
                {
                    content: '与您沟通有关服务更新和促销活动'
                }
            ]
        },
        regulationsFour: {
            subTitle: '4，信息共享与披露',
            content: '我们不会出售您的个人信息。但在以下情况下，我们可能会共享您的信息：',
            list: [
                {
                    content: '与关联公司及服务提供商签署保密协议的前提下共享'
                },
                {
                    content: '根据法律要求与监管机构和执法机关共享'
                },
                {
                    content: '经您同意后与业务合作伙伴共享用于运营或促销目的'
                }
            ]
        },
        regulationsFive: {
            subTitle: '5，数据保留',
            content: '我们仅在达成本政策所述目的或遵守法律义务所需的期限内保留您的个人信息。'
        },
        regulationsSex: {
            subTitle: '6，数据安全',
            content: '我们采取适当的技术和组织措施，以防止您的个人数据被未经授权访问、披露、修改或销毁。'
        },
        regulationsSeven: {
            subTitle: '7，您的权利',
            content: '您有权：',
            list: [
                {
                    content: '访问和更正您的个人信息'
                },
                {
                    content: '要求删除或限制对您信息的处理'
                },
                {
                    content: '随时撤回您的同意'
                },
                {
                    content: '向数据保护机构投诉'
                }
            ]
        },
        regulationsEight: {
            subTitle: '8，Cookies与追踪技术',
            content: '我们使用Cookies和类似技术来提升您的使用体验，分析网站使用情况，并提供个性化内容。'
        },
        regulationsNine: {
            subTitle: '9，国际数据传输',
            content: '您的信息可能在您所在国家以外的司法管辖区进行处理和存储。我们将确保采取适当的保护措施。'
        },
        regulationsTen: {
            subTitle: '10，政策变更',
            content: '我们保留随时更新本隐私条款的权利。如有重大变更，我们将通过网站或其他方式通知您。'
        }
    },
    helpCenterList: [
        {
            title: '1，如何注册成为ubpay的用户？',
            content: '下载ubapy的APP，打开APP之后点击“注册”按钮，您可以用电子邮箱注册账号。当收到系统发送的验证码邮件之后，输入邮件验证码、密码，勾选用户注册协议，提交之后即可创建ubpay账号。'
        },
        {
            title: '2，是否必须完成实名认证(KYC)才能使用ubpay？',
            content: '数字资产充值，部分地区可在未实名的情况下使用；如果需要申请银行卡服务，你必须完成KYC认证。KYC包括提交身份证明文件(例如：身份证、护照、驾照)，审核时间通常为1~12小时之内。'
        },
        {
            title: '3，有账号更改邮箱服务吗？',
            content: '有的，在个人中心有更改登录邮箱的功能，输入新邮箱，提交系统发送的邮件验证码之后，可以更改登录邮箱。'
        },
        {
            title: '4，忘记密码怎么办？',
            content: '在登录页面点击“忘记密码”，输入登录邮箱之后，会收到系统发送的邮件验证码，输入验证码之后可以重置密码。但是频繁重置可能被系统检测到从而进行风控。'
        },
        {
            title: '5，一个人可以注册多个ubpay的账号吗？',
            content: '出于风控考虑，我们不建议用户注册多个ubpay的账号。'
        },
        {
            title: '6，可以申请哪些银行卡？',
            content: '我们提供两大发卡机构Mastercard和Discover® Global Network的银行卡。卡片分为实体卡和虚拟卡，虚拟卡即开即用，方便ubpay用户选择。'
        },
        {
            title: '7，什么是虚拟银行卡？',
            content: '虚拟银行卡是ubpay为用户提供的两大发卡机构的银行卡，虚拟银行卡是一种没有实体卡片的银行卡，以数字卡片的形式存在，包含卡号、有效期、CVV等信息。用户可以使用虚拟卡在网上进行支付，虚拟卡与实体卡具备相似功能，但使用更便捷、匿名性更高、安全性更强。'
        },
        {
            title: '8，虚拟银行卡支持哪些用途？',
            content: 'ubpay虚拟银行卡可应用于：绑定第三方支付平台支付宝、微信支付、ApplePay、GooglePay、PayPal等钱包进行线上支付。也可以用于在线下部分ATM机上进行取现。'
        },
        {
            title: '9，虚拟银行卡支持哪些币种？',
            content: '虚拟银行卡币种包括：美元（USD）、欧元（EUR）、英镑（GBP）等。我们还提供多币种虚拟卡，支持根据消费地自动换汇扣款，避免货币转换手续费。'
        },
        {
            title: '10，一张虚拟银行卡可以使用多久？',
            content: 'ubpay虚拟银行卡有效期通常为1~2年不等，当到了一年期之后可以续卡一年。有效期通常在卡片详情中明确显示。'
        }
    ],
    tfVersionDownload: [
        {
            content: '1，下载 TestFlight：打开 iOS 设备上的 App Store，搜索 “TestFlight”，找到 TestFlight 应用并点击 “获取” 进行下载和安装。'
        },
        {
            content: '2，获取邀请：开发者会在 App Store Connect 中创建公共测试链接或向特定用户发送邀请邮件。用户会收到包含邀请链接的邮件，或者从其他渠道获得开发者提供的邀请链接。'
        },
        {
            content: '3，使用邀请链接：点击邀请链接，系统会自动打开 TestFlight 应用。如果未自动打开，可手动打开 TestFlight。'
        },
        {
            content: '4，安装应用：在 TestFlight 应用中，点击 “开始测试” 按钮，然后点击 “安装” 按钮，等待应用下载和安装完成。安装完成后，即可在主屏幕上找到并打开应用进行使用。'
        }
    ]
}
export const aboutUBPay = {
    title: 'About UBPay',
    content: {
        // subTitle: 'UBPay is a fintech company focused on building next-generation digital currency payment systems. We provide secure, efficient, and compliant crypto payment solutions for global users and businesses.',
        // content: 'We help businesses enter the digital asset space with cross-border payment freedom, transparent stablecoin settlement, and stable support for high-frequency trading. Our platform supports major public chains like Ethereum and TRON, offering services such as payments, currency exchange, settlement, auto-clearing, and KYC withdrawals — creating future-ready digital payment infrastructure.'
        subTitle: 'UBPay 是一家专注于构建支付系统的金融科技公司，致力于为全球商户和个人提供安全、高效、合规的收付款解决方案。',
        content: '我们赋能企业接入资产世界，实现跨境支付自由、结算透明化、以及高频交易的稳定支持。我们的平台支持收款、换汇、结算、自动清算等一站式服务，旨在打造面向未来的合规支付基础设施。'
    }
}
